import { IApplicationState } from '../../types/redux';

/**
 * Выбирает список групп документов и статус
 */
export const selectDocumentGroupList = ({ documentGroupList }: IApplicationState) => documentGroupList;
